import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../../../public/icons/explorer/star.svg'
import _imports_1 from '../../../public/icons/explorer/folder.svg'
import _imports_2 from '../../../public/icons/processV2.svg'
import _imports_3 from '../../../public/icons/explorer/excel.svg'
import _imports_4 from '../../../public/icons/explorer/power_bi.svg'
import _imports_5 from '../../../public/icons/explorer/generic.svg'
import _imports_6 from '../../../public/icons/explorer/reportbook.svg'
import _imports_7 from '../../../public/icons/explorer/xl3.svg'
import _imports_8 from '../../../public/icons/explorer/calc_script.svg'
import _imports_9 from '../../../public/icons/explorer/word.svg'
import _imports_10 from '../../../public/icons/explorer/ppt.svg'


const _hoisted_1 = {
  key: 0,
  class: "icon",
  src: _imports_0
}
const _hoisted_2 = {
  key: 1,
  class: "icon theme-svg",
  src: _imports_1
}
const _hoisted_3 = {
  key: 2,
  class: "icon_processV2 theme-svg",
  src: _imports_2
}
const _hoisted_4 = {
  key: 3,
  class: "icon theme-svg",
  src: _imports_3
}
const _hoisted_5 = {
  key: 4,
  class: "icon theme-svg",
  src: _imports_4
}
const _hoisted_6 = {
  key: 5,
  class: "icon theme-svg",
  src: _imports_5
}
const _hoisted_7 = {
  key: 6,
  class: "icon theme-svg",
  src: _imports_6
}
const _hoisted_8 = {
  key: 7,
  class: "icon theme-svg",
  src: _imports_7
}
const _hoisted_9 = {
  key: 8,
  class: "icon theme-svg",
  src: _imports_8
}
const _hoisted_10 = {
  key: 9,
  class: "icon",
  src: _imports_9
}
const _hoisted_11 = {
  key: 10,
  class: "icon",
  src: _imports_10
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.Fso.objectType === _ctx.FileSystemType.Folder && _ctx.Fso.id === 0.1)
    ? (_openBlock(), _createElementBlock("img", _hoisted_1))
    : (_ctx.Fso.objectType === _ctx.FileSystemType.Folder)
      ? (_openBlock(), _createElementBlock("img", _hoisted_2))
      : ((_ctx.Fso.objectType === _ctx.FileSystemType.Process ||
        _ctx.Fso.objectType === _ctx.FileSystemType.InteractiveProcess))
        ? (_openBlock(), _createElementBlock("img", _hoisted_3))
        : (_ctx.Fso.objectType === _ctx.FileSystemType.Form)
          ? (_openBlock(), _createElementBlock("img", _hoisted_4))
          : (_ctx.Fso.objectType === _ctx.FileSystemType.PowerBI)
            ? (_openBlock(), _createElementBlock("img", _hoisted_5))
            : (_ctx.Fso.objectType === _ctx.FileSystemType.Generic)
              ? (_openBlock(), _createElementBlock("img", _hoisted_6))
              : (_ctx.Fso.objectType === _ctx.FileSystemType.ReportBook)
                ? (_openBlock(), _createElementBlock("img", _hoisted_7))
                : (_ctx.Fso.objectType === _ctx.FileSystemType.XL3)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_8))
                  : (_ctx.Fso.objectType === _ctx.FileSystemType.CalcScript)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_9))
                    : (_ctx.Fso.objectType === _ctx.FileSystemType.DocxReport)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_10))
                      : (_ctx.Fso.objectType === _ctx.FileSystemType.PptxReport)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_11))
                        : _createCommentVNode("", true)
}